import React from 'react';import './ProductFormByType.css';
/**
 * Growzelt-spezifisches Formular
 * Blanko-Formular für Growzelte und Anbaubehälter
 */
function TentForm({ formData, handleChange, disabled }) {
  return (
    <div className="product-type-form-section">
      <h3>🎪 Growzelt-Spezifikationen</h3>

      <div className="form-row">
        <div className="form-group">
          <label htmlFor="tentSize">📏 Zeltgröße (cm)</label>
          <select
            id="tentSize"
            name="tentSize"
            value={formData.tentSize || ''}
            onChange={handleChange}
            disabled={disabled}
          >
            <option value="">-- Bitte wählen --</option>
            <optgroup label="Kleine Zelte">
              <option value="40x40">40 x 40 cm</option>
              <option value="40x60">40 x 60 cm</option>
              <option value="40x80">40 x 80 cm</option>
              <option value="40x100">40 x 100 cm</option>
            </optgroup>
            <optgroup label="Mittlere Zelte">
              <option value="60x60">60 x 60 cm</option>
              <option value="60x100">60 x 100 cm</option>
              <option value="60x120">60 x 120 cm</option>
              <option value="60x150">60 x 150 cm</option>
            </optgroup>
            <optgroup label="Große Zelte">
              <option value="80x80">80 x 80 cm</option>
              <option value="80x100">80 x 100 cm</option>
              <option value="80x120">80 x 120 cm</option>
              <option value="80x150">80 x 150 cm</option>
              <option value="80x200">80 x 200 cm</option>
            </optgroup>
            <optgroup label="Profi Zelte">
              <option value="100x100">100 x 100 cm</option>
              <option value="100x150">100 x 150 cm</option>
              <option value="100x200">100 x 200 cm</option>
              <option value="120x120">120 x 120 cm</option>
              <option value="120x150">120 x 150 cm</option>
              <option value="120x180">120 x 180 cm</option>
              <option value="120x200">120 x 200 cm</option>
              <option value="120x240">120 x 240 cm</option>
            </optgroup>
            <optgroup label="Großzelte">
              <option value="150x150">150 x 150 cm</option>
              <option value="150x200">150 x 200 cm</option>
              <option value="150x240">150 x 240 cm</option>
              <option value="200x200">200 x 200 cm</option>
              <option value="240x240">240 x 240 cm</option>
            </optgroup>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="tentHeight">📏 Höhe (cm)</label>
          <input
            type="number"
            id="tentHeight"
            name="tentHeight"
            value={formData.tentHeight || ''}
            onChange={handleChange}
            placeholder="z.B. 160"
            step="1"
            disabled={disabled}
          />
        </div>

        <div className="form-group">
          <label htmlFor="tentArea">📐 Grundfläche (m²)</label>
          <input
            type="number"
            id="tentArea"
            name="tentArea"
            value={formData.tentArea || ''}
            onChange={handleChange}
            placeholder="z.B. 0.36"
            step="0.01"
            disabled={disabled}
          />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label htmlFor="material">🧵 Material</label>
          <select
            id="material"
            name="material"
            value={formData.material || ''}
            onChange={handleChange}
            disabled={disabled}
          >
            <option value="">-- Keine Angabe --</option>
            <option value="Mylar">Mylar</option>
            <option value="Canvas">Canvas</option>
            <option value="Oxford">Oxford-Nylon</option>
            <option value="Polyester">Polyester</option>
            <option value="PVC">PVC</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="reflectivity">✨ Reflektivität (%)</label>
          <input
            type="number"
            id="reflectivity"
            name="reflectivity"
            value={formData.reflectivity || ''}
            onChange={handleChange}
            placeholder="z.B. 95"
            step="1"
            min="0"
            max="100"
            disabled={disabled}
          />
        </div>

        <div className="form-group">
          <label htmlFor="thickness">📏 Dicke (mm)</label>
          <input
            type="number"
            id="thickness"
            name="thickness"
            value={formData.thickness || ''}
            onChange={handleChange}
            placeholder="z.B. 18"
            step="0.1"
            disabled={disabled}
          />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label htmlFor="framework">🏗️ Rahmenkonstruktion</label>
          <select
            id="framework"
            name="framework"
            value={formData.framework || ''}
            onChange={handleChange}
            disabled={disabled}
          >
            <option value="">-- Keine Angabe --</option>
            <option value="Stahlrohre">Stahlrohre</option>
            <option value="Kunststoffrohre">Kunststoffrohre</option>
            <option value="Aluminium">Aluminium</option>
            <option value="Holz">Holz</option>
            <option value="Hybrid">Hybrid</option>
          </select>
        </div>

        <div className="form-group">
          <label>🚪 Mit Bodenfläche</label>
          <div className="checkbox-label">
            <input
              type="checkbox"
              id="hasFloor"
              name="hasFloor"
              checked={formData.hasFloor || false}
              onChange={(e) => {
                handleChange({ target: { name: 'hasFloor', value: e.target.checked } });
              }}
              disabled={disabled}
            />
            <span>Zelt mit Bodenfläche</span>
          </div>
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="tentFeatures">Spezielle Features (optional)</label>
        <textarea
          id="tentFeatures"
          name="tentFeatures"
          value={formData.tentFeatures || ''}
          onChange={handleChange}
          placeholder="z.B. Fenster, Belüftungsöffnungen, integrierte Kabel-Durchführungen, etc."
          rows="3"
          disabled={disabled}
        />
      </div>
    </div>
  );
}

export default TentForm;
